import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "store";

type AccessSlice = {
	qrCode: {
		code: string | null;
	};
};

const initialState: AccessSlice = {
	qrCode: {
		code: null,
	},
};

export const accessSlice = createSlice({
	name: "access",
	initialState: initialState,
	reducers: {
		// Writers of the access QR, for the next reader wondering where this comes from:
		// - DeviceContext.onData      — the live FRIDGE_SUBSCRIPTION frame (authoritative, primary path)
		// - handleSetDishTypes        — the hourly price refetch re-asserts it alongside prices
		// - useQrCodeLifecycleLogging — the post-transaction self-heal refetch when a rotation was missed
		// OrderStep2 also nulls it at a local transaction's start (the scanned code is consumed).
		setQrCode: (state, { payload }: PayloadAction<string | null>) => {
			state.qrCode.code = payload;
		},
	},
});

export const { setQrCode } = accessSlice.actions;
export const selectQRCode = (state: RootState) => state.access?.qrCode?.code ?? null;
export default accessSlice.reducer;
